import { AuthenticationClient, EmailScene } from "authing-js-sdk";
import i18n from './vue-i18n'

import errorInfo from './error.json'
const authenticationClient = new AuthenticationClient({
  userPoolId: "611343f609133b74d36e645f",
});

function formatError(error) {
  if (typeof error === "string") return error;
  if (error.request) {
    // 网络请求错误
    if (error.response) return JSON.stringify(error.response.data);
    else return JSON.stringify(error.request);
  } else if (typeof error.message === "object") {
    // 业务逻辑错误
    
    if (error.message.code) {
      return errorInfo[error.message.code] ? errorInfo[error.message.code][i18n.locale] :error.message.message;
    } else {
      return JSON.stringify(error.message);
    }
  } else {
    try {
      let msg = error
      return errorInfo[msg.code] ? errorInfo[msg.code][i18n.locale] : msg.message;
    } catch {
      return error && error.message;
    }
  }
}

const Auth = async function({ eventName, params,scene }) {
  if (!eventName) return;
  try {
    return await authenticationClient[eventName](...params,scene || EmailScene[scene] );
  } catch (e) {
    throw formatError(e);
  }
};
export default Auth;
